module.exports = __webpack_public_path__ + "img/a87e3e6.png";